import { appSettingsHubDe } from './settingsHub.de.js';
import { appOmgevingDe } from './omgevingApp.de.js';
import { appRecurrenceDe } from './recurrenceApp.de.js';
import { appDomeinDe } from './domeinApp.de.js';
import { appMemorizeDe } from './memorizeApp.de.js';
import { appSamenDe } from './samenApp.de.js';
import { appCareDe } from './careApp.de.js';
import { appCultureDe } from './cultureApp.de.js';
import { appActivitiesDe, appChecklistDe } from './golf2App.de.js';
import { appGrowthDe, appSchoolDe } from './groeiSchoolApp.de.js';
import { appBoardConfigDe } from './boardConfigApp.de.js';
import { appAgendaViewsDe, appHomeDe, appWeatherDetailDe } from './homeApp.de.js';
import { appDevicesG4De, appEditorG4De, appPrivacyRightsDe } from './golf4App.de.js';
import { appFeedsDe, appPlacesDe, appTravelDe } from './kaartApp.de.js';
import { appLanguagesDe } from './languagesApp.de.js';
import { appReadAloudDe } from './readAloudApp.de.js';
import { appModulesDe } from './modulesApp.de.js';
import { appHouseholdsDe } from './householdsApp.de.js';
import { appProfileDe } from './profileApp.de.js';
import { appPushDe } from './pushApp.de.js';
import { appRemindersDe } from './remindersApp.de.js';
import { appTodoDe } from './todoApp.de.js';
import { appMissedDe } from './missedApp.de.js';
import { appBillingDe } from './billingApp.de.js';
import { appRidesDe } from './ridesApp.de.js';
import { appTimePickerDe } from './timePicker.de.js';
import { appVirtualDeviceDe } from './virtualDevice.de.js';
import { appBoardViewDe } from './boardViewApp.de.js';
import { appDailyDe } from './dailyApp.de.js';
import { appThemesDe } from './themesApp.de.js';
import { appGolf6De } from './golf6App.de.js';
import { appWerklijstDe } from './werklijstApp.de.js';
import { appChildConsentDe, appPrivacyStatementDe } from './golf5App.de.js';
// Duits (de-DE): teksten van de ouder-webapp (zelfde vorm als app.nl.ts). Du-vorm, korte zinnen,
// werkwoorden op knoppen (zoals de je-vorm in het Nederlands). Wat ontbreekt valt terug op nl.
export const appDe = {
    // Golf 7 (0048): Soera's leren (memorizeApp.de.ts).
    // Nieuwe adressen (amumin.app, board.amumin.app): bedrijfsgegevens en meldingen (domeinApp.de.ts).
    domein: appDomeinDe,
    memorize: appMemorizeDe,
    // Golf 8 (0049): Samen wonen (samenApp.de.ts).
    samen: appSamenDe,
    // Golf 8 (0050): dagelijkse check-in en familiekring (careApp.de.ts).
    care: appCareDe,
    reminders: appRemindersDe,
    // 0058: to-do's zonder datum of tijd (todoApp.de.ts).
    todo: appTodoDe,
    missed: appMissedDe,
    // 0065: aanmelden, abonnement en de banner na de proefmaand (billingApp.de.ts).
    billing: appBillingDe,
    profile: appProfileDe,
    culture: appCultureDe,
    timePicker: appTimePickerDe,
    ridesPerDay: appRidesDe,
    modules: appModulesDe,
    // Golf 6b (0043): soorten huishouden en het beurtrooster (householdsApp.de.ts).
    households: appHouseholdsDe,
    checklist: appChecklistDe,
    activities: appActivitiesDe,
    languages: appLanguagesDe,
    readAloud: appReadAloudDe,
    // Golf 3-integratie: groei en school (0032), kaart en agenda (0034), werklijst, virtuele iPad (0028).
    growth: appGrowthDe,
    school: appSchoolDe,
    places: appPlacesDe,
    travel: appTravelDe,
    feeds: appFeedsDe,
    werklijst: appWerklijstDe,
    virtualDevice: appVirtualDeviceDe,
    // Menu Board: het echte bord live bekijken (boardViewApp.de.ts).
    boardView: appBoardViewDe,
    // WP4: Sterren in Taken, Ritten in Agenda, Prikbord, Kinderen, Recepten en Weekmenu (dailyApp.de.ts).
    daily: appDailyDe,
    themes: appThemesDe,
    // Golf 6b: Vandaag als widgets, agendaweergaven en het weerdetail (homeApp.de.ts).
    home: appHomeDe,
    // Scherm inrichten: widgets van het bord per tablet (boardConfigApp.de.ts).
    boardConfig: appBoardConfigDe,
    agendaViews: appAgendaViewsDe,
    weatherDetail: appWeatherDetailDe,
    golf6: appGolf6De,
    // 0036: Jouw gegevens (golf 4).
    privacyRights: appPrivacyRightsDe,
    // Instellingen als overzicht (settingsHub.de.ts).
    settingsHub: appSettingsHubDe,
    // Omgevingen, eigen thema, agendaverbindingen (omgevingApp.de.ts).
    omgeving: appOmgevingDe,
    // Herhaling in gewone taal (recurrenceApp.de.ts; packages/domain summaryLang.ts).
    recurrenceText: appRecurrenceDe,
    // Golf 5 (0044): toestemming voor een kindlogin of foto; de privacyverklaring (golf5App.de.ts).
    childConsent: appChildConsentDe,
    privacyStatement: appPrivacyStatementDe,
    // 0038: meldingen op je telefoon (pushApp.de.ts).
    push: appPushDe,
    nav: {
        // 0060: module Notities.
        notes: 'Notizen',
        // 0064: module Fotolijst.
        photos: 'Fotorahmen',
        kompas: 'Gesundes Gewicht',
        // 0069: module Geldzaken (privé).
        money: 'Geldsachen',
        // Oprichter 6 okt: eigen to-do's in Mijn omgeving.
        myTodos: 'Meine To-dos',
        today: 'Heute',
        board: 'Board',
        agenda: 'Kalender',
        tasks: 'Aufgaben',
        rewards: 'Belohnungen',
        approvals: 'Bestätigen',
        members: 'Familie',
        devices: 'Tablets',
        settings: 'Einstellungen',
        security: 'Sicherheit',
        household: 'Haushalt einrichten',
        rides: 'Fahrten',
        more: 'Mehr',
        // WP2 (compact-plan): de vijf vaste plekken en de samengevoegde pagina's onder Meer.
        pinboard: 'Pinnwand',
        children: 'Kinder',
        together: 'Gemeinsam',
        boardHub: 'Board',
        boardView: 'Ansicht',
        stars: 'Sterne',
        membersTab: 'Mitglieder',
        circle: 'Kreis',
        forYou: 'Für dich',
        forYouWaiting: 'Zu genehmigen: {n}',
        menu: 'Menü',
        logout: 'Abmelden',
        main: 'Hauptmenü',
        skip: 'Zum Inhalt',
        growth: 'Wachstum',
        school: 'Schule',
        admin: 'Verwaltung',
        werklijst: 'Arbeitsliste',
    },
    common: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        add: 'Hinzufügen',
        close: 'Schließen',
        back: 'Zurück',
        next: 'Weiter',
        later: 'Später',
        undo: 'Rückgängig',
        retry: 'Erneut versuchen',
        info: 'Erklärung',
        moreCount: '+{n} weitere',
        loading: 'Wird geladen…',
        optional: 'optional',
        yes: 'Ja',
        no: 'Nein',
        none: 'Keine',
        everyone: 'Alle',
        minutes: { one: '{count} Minute', other: '{count} Minuten' },
        minutesShort: '{count} Min.',
        hoursMinutes: '{h} Std. {m} Min.',
        hours: { one: '{count} Stunde', other: '{count} Stunden' },
        points: { one: '{count} Punkt', other: '{count} Punkte' },
        by: 'von {name}',
        unknown: 'Unbekannt',
        errorLoad: 'Das hat gerade nicht geklappt. Versuch es noch einmal.',
        savedOk: 'Gespeichert',
    },
    offline: 'Keine Verbindung zum Server. Wir versuchen es automatisch erneut.',
    today: {
        goodMorning: 'Guten Morgen',
        goodAfternoon: 'Guten Tag',
        goodEvening: 'Guten Abend',
        goodNight: 'Gute Nacht',
        week: 'Woche {week}',
        next: 'Gleich',
        now: 'Läuft gerade',
        startsIn: 'in {time}',
        endsIn: 'noch {time}',
        nothingNext: 'Heute ist nichts mehr geplant',
        nothingNextBody: 'Zeit füreinander.',
        agenda: 'Kalender heute',
        addEvent: 'Termin',
        addEventLong: 'Termin hinzufügen',
        tasks: 'Aufgaben heute',
        tasksAll: 'Alle Aufgaben',
        noTasks: 'Heute keine Aufgaben',
        approvals: 'Bestätigen',
        approvalsWaiting: {
            one: '{count} Sache wartet auf dich',
            other: '{count} Sachen warten auf dich',
        },
        approvalsView: 'Ansehen',
        ridesOpen: {
            one: '{count} Fahrt ohne Fahrer',
            other: '{count} Fahrten ohne Fahrer',
        },
        ridesAll: 'Alle Fahrten',
        tomorrow: 'Morgen',
        tomorrowNothing: 'Für morgen steht noch nichts an.',
        toAgenda: 'Zum Kalender',
        goalsTitle: 'Sparen',
    },
    agenda: {
        title: 'Kalender',
        prev: 'Zurück',
        next: 'Weiter',
        today: 'Heute',
        newEvent: 'Termin',
        filter: 'Anzeigen für',
        filterAll: 'Alle',
        emptyDay: 'An diesem Tag ist noch nichts geplant',
        emptyDayBody: 'Tippe auf +, um etwas hinzuzufügen.',
        emptyWeek: 'Diese Woche ist noch nichts geplant',
        emptyRange: 'Noch nichts geplant',
        weekTitle: 'Woche {week} · {range}',
        trash: 'Papierkorb',
        trashIntro: 'Gelöschte Termine bleiben 30 Tage aufbewahrt.',
        trashEmpty: 'Der Papierkorb ist leer.',
        restore: 'Wiederherstellen',
        restoreUntil: 'Wiederherstellbar bis {date}',
        restored: '{title} steht wieder im Kalender',
        restoreExpired: 'Dieser Termin ist schon länger als 30 Tage weg und lässt sich nicht mehr wiederherstellen.',
        export: 'Kalender exportieren',
        exportIntro: 'Lade den Kalender als .ics-Datei für dein Handy oder deinen Computer herunter.',
        exportHousehold: 'Ganze Familie',
        moved: '{title} verschoben auf {when}',
        moveFailed: 'Das Verschieben hat nicht geklappt. Der Termin steht wieder an seinem Platz.',
        dragHint: 'Zieh einen Termin, um ihn zu verschieben.',
        allDay: 'Ganztägig',
        moreItems: '+{count} weitere',
    },
    event: {
        when: 'Wann',
        leave: 'Losfahren',
        who: 'Wer',
        where: 'Wo',
        notes: 'Notiz',
        repeats: 'Wiederholung',
        rides: 'Bringen und Abholen',
        dropoff: 'Bringen',
        pickup: 'Abholen',
        driverOpen: 'Wer fährt?',
        driverIs: '{name} fährt',
        iDrive: 'Ich fahre',
        chooseDriver: 'Wähle, wer fährt',
        nobody: 'Noch niemand',
        driverSaved: '{name} fährt',
        driverCleared: 'Fahrer entfernt',
        depart: 'Abfahrt {time}',
        travel: '{count} Min. Fahrzeit',
        edit: 'Bearbeiten',
        cancelOne: 'Diesmal absagen',
        cancelledOne: '{title} fällt diesmal aus',
        cancelled: 'Abgesagt',
        restoreOne: 'Doch stattfinden lassen',
        restoredOne: '{title} findet doch statt',
        resetOne: 'Zurück zum normalen Termin',
        resetDone: 'Dieser Termin ist wieder wie die Serie',
        resetKeptRide: 'Dieser Termin ist wieder wie die Serie. Wer fährt, bleibt so, wie du es für dieses Mal geregelt hast.',
        resetKeptReminder: 'Dieser Termin ist wieder wie die Serie. Die übersprungene Erinnerung bleibt diesmal stumm.',
        resetKeptBoth: 'Dieser Termin ist wieder wie die Serie. Wer fährt und die übersprungene Erinnerung bleiben so, wie du sie für dieses Mal geregelt hast.',
        moved: 'Verschoben',
        changed: 'Geändert',
        delete: 'Löschen',
        deleted: '{title} gelöscht',
        deleteTitle: '{title} löschen?',
        deleteBody: 'Du kannst ihn 30 Tage lang aus dem Papierkorb wiederherstellen.',
        duplicate: 'Duplizieren',
        duplicated: 'Kopie erstellt',
        history: 'Was hat sich geändert?',
        historyEmpty: 'Noch keine Änderungen.',
        historyItem: '{who} · {when}',
        conflict: 'Gleichzeitig mit etwas anderem',
        conflictWith: {
            one: '{names} hat dann auch {title}',
            other: '{names} haben dann auch {title}',
        },
        conflictDrive: '{name} fährt um {time} und hat dann noch {title}',
        lastChanged: 'Zuletzt geändert von {name}',
        notFound: 'Diesen Termin gibt es nicht mehr.',
        action: {
            create: 'erstellt',
            update: 'geändert',
            delete: 'gelöscht',
            restore: 'wiederhergestellt',
            split: 'ab hier geändert',
            cancel: 'abgesagt',
            uncancel: 'findet doch statt',
            move: 'verschoben',
            override: 'diesmal angepasst',
            override_clear: 'zurück zur Serie',
            role: 'Fahrer geändert',
        },
    },
    editor: {
        ...appEditorG4De,
        newTitle: 'Neuer Termin',
        editTitle: 'Termin bearbeiten',
        title: 'Was',
        titlePlaceholder: 'Zum Beispiel Schwimmkurs',
        titleHint: 'Kurz und klar, zum Beispiel Schwimmkurs',
        templates: 'Schnell wählen',
        picto: 'Symbol',
        pictoChoose: 'Wähle ein Symbol',
        pictoChange: 'Anderes Symbol',
        who: 'Für wen',
        everyone: 'Alle',
        date: 'Datum',
        allDay: 'Ganztägig',
        start: 'Von',
        end: 'Bis',
        duration: 'Dauer',
        endDate: 'Bis einschließlich',
        endBeforeStart: 'Das Ende liegt vor dem Beginn.',
        repeat: 'Wiederholen',
        repeatNone: 'Nie',
        repeatDaily: 'Jeden Tag',
        repeatWeekly: 'Jede Woche',
        repeatBiweekly: 'Alle zwei Wochen',
        repeatMonthly: 'Jeden Monat',
        repeatYearly: 'Jedes Jahr',
        onDays: 'An welchen Tagen',
        monthlyHow: 'Welcher Tag im Monat',
        monthlyDay: 'Am {day}.',
        monthlyLast: 'Am letzten Tag',
        monthlyNth: 'Am {ordinal} {weekday}',
        ordinal: {
            '1': 'ersten',
            '2': 'zweiten',
            '3': 'dritten',
            '4': 'vierten',
            '-1': 'letzten',
        },
        parity: 'Welche Wochen',
        parityAll: 'Alle Wochen',
        parityEven: 'Gerade Wochen',
        parityOdd: 'Ungerade Wochen',
        ends: 'Endet',
        endsNever: 'Nie',
        endsCount: 'Nach einer bestimmten Anzahl',
        endsUntil: 'An einem Datum',
        count: 'Anzahl',
        until: 'Bis einschließlich',
        nextDates: 'Die nächsten Male',
        rides: 'Bringen und Abholen',
        ridesHint: 'Wer bringt und wer holt ab? Wähle „Noch unklar“, wenn du es noch nicht weißt.',
        dropoff: 'Bringen',
        pickup: 'Abholen',
        roleNone: 'Nicht nötig',
        roleOpen: 'Noch offen (wer fährt?)',
        travel: 'Fahrzeit',
        travelNone: 'Keine',
        travelOwn: 'Eigene Zeit…',
        travelOwnLabel: 'Fahrzeit in Minuten',
        /** 0056: dezelfde reistijd ook ná de afspraak. */
        travelBack: 'Rückweg',
        travelBackHint: 'Dieselbe Fahrzeit auch nach dem Termin, für den Heimweg.',
        travelAuto: 'Automatisch (über den Ort)',
        travelAutoWith: 'Automatisch ({minutes} Min.)',
        departureAlert: 'Hinweis zum Losfahren',
        departureAlertHint: 'Das Board zeigt, wann du losfahren musst.',
        departureNone: 'Kein Hinweis',
        departureBefore: '{count} Min. vorher',
        location: 'Wo',
        locationPlaceholder: 'Zum Beispiel Hallenbad',
        notes: 'Notiz',
        notesPlaceholder: 'Schwimmtasche und Handtuch mitnehmen',
        category: 'Art',
        more: 'Mehr Optionen: Bringen und Abholen, Ort, Notiz',
        less: 'Weniger Optionen',
        fullScreen: 'Vollbild',
        smallScreen: 'Verkleinern',
        create: 'Termin speichern',
        save: 'Speichern',
        created: '{title} steht im Kalender',
        saved: 'Termin gespeichert',
        conflictNotice: {
            one: '{names} hat dann auch {title} ({time}).',
            other: '{names} haben dann auch {title} ({time}).',
        },
        orphansTitle: 'Es gibt einzelne Änderungen',
        orphansBody: 'Manche Male hattest du einzeln angepasst, und die fallen jetzt weg. Was möchtest du damit machen?',
        orphansKeep: 'Als einzelne Termine behalten',
        orphansDelete: 'Verwerfen',
        onlyThisNoRepeat: 'Eine Wiederholung änderst du für dieses und die folgenden Male oder für die ganze Serie.',
        titleRequired: 'Gib ein, was es ist.',
        memberRequired: 'Wähle, für wen es ist.',
        categories: {
            sport: 'Sport',
            school: 'Schule',
            medisch: 'Arzt und Zahnarzt',
            sociaal: 'Verabredung',
            werk: 'Arbeit',
            verjaardag: 'Geburtstag',
            overig: 'Sonstiges',
        },
    },
    scope: {
        thisHint: 'Nur {date}',
        followingHint: 'Ab {date}',
        allHint: 'Alle Male, auch frühere',
        deleteFollowing: 'Diesen und folgende löschen',
        confirm: 'Weiter',
    },
    rides: {
        title: 'Fahrten',
        subtitle: 'Wer bringt und holt wen ab? Die nächste Woche im Überblick.',
        open: 'Noch kein Fahrer',
        arranged: 'Geregelt',
        empty: 'Alle Fahrten sind geregelt.',
        emptyBody: 'Niemand muss nach einer Mitfahrt suchen.',
        none: 'Diese Woche keine Fahrten.',
        noneBody: 'Leg bei einem Termin fest, wer bringt oder abholt, dann erscheint es hier.',
        iDrive: 'Ich fahre',
        choose: 'Wählen',
        dropoff: 'Bringen',
        pickup: 'Abholen',
        notLinked: 'Dein Login ist noch mit keinem Familienmitglied verknüpft. Wähle unten, wer fährt.',
    },
    tasks: {
        title: 'Aufgaben',
        viewToday: 'Heute',
        viewWeek: 'Woche',
        viewAll: 'Alle',
        add: 'Aufgabe',
        addLong: 'Aufgabe hinzufügen',
        newTitle: 'Neue Aufgabe',
        editTitle: 'Aufgabe bearbeiten',
        library: 'Ideen für Aufgaben',
        libraryIntro: 'Wähle eine Aufgabe und für wen sie ist. Die Punkte passen zum Alter.',
        libraryAdd: 'Hinzufügen',
        libraryFor: 'Für wen',
        what: 'Was',
        titlePlaceholder: 'Zum Beispiel Tisch decken',
        who: 'Für wen',
        mode: 'Wie',
        modeEach: 'Jeder für sich',
        modeEachHint: 'Jeder macht es selbst und bekommt eigene Punkte.',
        modeTogether: 'Zusammen',
        modeTogetherHint: 'Ihr macht es zusammen; ein Häkchen für alle.',
        modeFirst: 'Wer zuerst',
        modeFirstHint: 'Wer es als Erstes macht, bekommt die Punkte.',
        repeat: 'Wie oft',
        repeatOnce: 'Einmal',
        repeatDaily: 'Jeden Tag',
        repeatWeekdays: 'An Werktagen',
        repeatWeekly: 'Jede Woche',
        repeatMonthly: 'Jeden Monat',
        onDays: 'An welchen Tagen',
        monthDay: 'Am Tag',
        monthLast: 'Letzter Tag',
        startDate: 'Ab',
        date: 'Am',
        dueDate: 'Spätestens',
        timeOfDay: 'Wann am Tag',
        tod: {
            any: 'Ganzer Tag',
            morning: 'Morgens',
            afternoon: 'Nachmittags',
            evening: 'Abends',
        },
        dueTime: 'Fertig um',
        points: 'Punkte',
        pointsHint: 'Wie viele Sterne bringt es? 0 geht auch.',
        approval: 'Bestätigung nötig',
        approvalHint: 'Mama oder Papa bestätigt die Aufgabe, bevor die Punkte zählen.',
        approvalHintNoPoints: 'Mama oder Papa prüft die Aufgabe, bevor sie als erledigt zählt.',
        description: 'Erklärung',
        create: 'Aufgabe speichern',
        created: '{title} ist bereit',
        saved: 'Aufgabe gespeichert',
        deleteTitle: '{title} löschen?',
        deleted: '{title} gelöscht',
        duplicateTitle: 'Diese Aufgabe gibt es schon',
        duplicateBody: 'Es gibt schon eine Aufgabe {title} für {names}. Trotzdem noch eine hinzufügen?',
        addAnyway: 'Trotzdem hinzufügen',
        emptyTitle: 'Noch keine Aufgaben',
        emptyBody: 'Fang mit etwas Kleinem an, wie Zähneputzen.',
        emptyToday: 'Heute keine Aufgaben',
        emptyTodayBody: 'Aufgaben für heute erscheinen hier.',
        progress: '{done} von {total} erledigt',
        completeFor: 'Abhaken für {name}',
        completed: '{title} abgehakt',
        revert: 'Wieder auf offen setzen',
        reverted: '{title} ist wieder offen',
        skip: 'Überspringen',
        skipped: '{title} übersprungen',
        unskip: 'Doch machen',
        state: {
            open: 'Offen',
            done: 'Erledigt',
            pending: 'Wartet auf Bestätigung',
            rejected: 'Noch einmal',
            skipped: 'Übersprungen',
            missed: 'Verpasst',
        },
        late: 'Noch von gestern',
        next: 'Nächstes Mal: {date}',
        noNext: 'Kein nächstes Mal',
        together: 'Zusammen',
        negativeTitle: 'Punkte fallen unter null',
        negativeBody: '{names} hat diese Punkte schon ausgegeben. Der Punktestand wird dann negativ.',
        negativeConfirm: 'Trotzdem zurücksetzen',
        perMember: 'Punkte pro Kind',
    },
    rewards: {
        title: 'Belohnungen',
        savings: 'Sparschweine',
        available: '{count} verfügbar',
        reserved: '{count} reserviert',
        goal: 'Spart für',
        noGoal: 'Noch kein Sparziel',
        setGoal: 'Sparziel',
        goalNone: 'Kein Ziel',
        chooseGoal: 'Wähle ein Sparziel',
        ledger: {
            task_credit: 'Aufgabe',
            task_reversal: 'Aufgabe zurückgesetzt',
            reward_debit: 'Belohnung',
            reward_refund: 'Belohnung zurück',
            manual_adjustment: 'Von einem Elternteil angepasst',
            bonus: 'Bonus',
            cleaning_credit: 'Putzen',
            cleaning_reversal: 'Putzen zurückgesetzt',
            // Golf 7 (0048): neutraal (blijft staan na wissen).
            learning_credit: 'Gut gelernt',
            learning_reversal: 'Gut gelernt zurückgesetzt',
        },
        goalMissing: {
            one: 'Noch {count} Punkt',
            other: 'Noch {count} Punkte',
        },
        goalReached: 'Genug gespart',
        goalSaved: 'Sparziel gespeichert',
        catalogue: 'Worauf ihr sparen könnt',
        add: 'Belohnung',
        addLong: 'Belohnung hinzufügen',
        newTitle: 'Neue Belohnung',
        editTitle: 'Belohnung bearbeiten',
        name: 'Was',
        namePlaceholder: 'Zum Beispiel Zusammen ein Eis holen',
        cost: 'Wie viele Sterne?',
        costHint: 'So viele Sterne kostet die Belohnung (1 bis 9999).',
        costInvalid: 'Wähle eine Zahl von 1 bis 9999.',
        forWhom: 'Für wen',
        forAll: 'Alle mit Punkten',
        limit: 'Wie oft',
        limitNone: 'So oft du willst',
        limitDay: '{count}× pro Tag',
        limitWeek: '{count}× pro Woche',
        limitMonth: '{count}× pro Monat',
        stock: 'Vorrat',
        stockNone: 'Unbegrenzt',
        stockLeft: 'Noch {count} übrig',
        created: '{name} hinzugefügt',
        saved: 'Belohnung gespeichert',
        archive: 'Entfernen',
        archiveTitle: '{name} entfernen?',
        archiveBody: 'Die Kinder sehen sie danach nicht mehr. Frühere Anfragen bleiben gespeichert.',
        archived: '{name} entfernt',
        requests: 'Anfragen',
        requestsEmpty: 'Keine offenen Anfragen.',
        give: 'Geben',
        given: '{name} an {member} gegeben',
        decline: 'Ablehnen',
        declined: 'Anfrage abgelehnt; die Punkte sind zurück',
        adjust: 'Punkte anpassen',
        adjustTitle: 'Punkte anpassen für {name}',
        adjustAmount: 'Wie viel',
        adjustAmountHint: 'Mit Minus ziehst du ab, zum Beispiel -5.',
        adjustReason: 'Warum',
        adjustReasonPlaceholder: 'Zum Beispiel Extra Hilfe im Garten',
        adjustInvalid: 'Wähle eine Zahl zwischen -999 und 999 (nicht 0).',
        adjustReasonRequired: 'Schreib kurz, warum.',
        adjusted: 'Punktestand von {name}: jetzt {count}',
        negativeTitle: 'Punktestand wird negativ',
        negativeBody: 'Dadurch fällt {name} unter null. Bist du sicher?',
        negativeConfirm: 'Ja, anpassen',
        history: 'Letzte Punkte',
        historyEmpty: 'Noch keine Punkte verdient.',
        pointsOff: 'Punkte sind aus',
        export: 'Exportieren (CSV)',
    },
    approvals: {
        title: 'Bestätigen',
        open: 'Offen',
        handled: 'Erledigt',
        approve: 'Bestätigen',
        approved: '{title} bestätigt',
        reject: 'Ablehnen',
        rejectTitle: '{title} ablehnen?',
        rejectNote: 'Was muss noch passieren?',
        rejectNotePlaceholder: 'Zum Beispiel Die Teller müssen noch auf den Tisch',
        rejected: '{title} geht zurück an {name}',
        asks: '{name} fragt',
        doneAt: 'fertig um {time}',
        doneAgo: 'fertig {ago}',
        give: 'Geben',
        decline: 'Ablehnen',
        notices: 'Gut zu wissen',
        emptyTitle: 'Alles erledigt',
        emptyBody: 'Nichts zu bestätigen.',
        handledEmpty: 'Hier steht, was du erledigt hast.',
        state: {
            fulfilled: 'Gegeben',
            declined: 'Abgelehnt',
            cancelled: 'Zurückgezogen',
            expired: 'Abgelaufen',
            pending: 'Offen',
        },
        together: 'zusammen mit {names}',
    },
    members: {
        title: 'Familie',
        intro: 'Alle, die auf dem Board stehen. Farbe und Gesicht siehst du überall wieder.',
        add: 'Familienmitglied',
        addLong: 'Familienmitglied hinzufügen',
        newTitle: 'Neues Familienmitglied',
        editTitle: '{name} bearbeiten',
        // Volgorde van het gezin (2026-10-01).
        orderHint: 'Mit den Pfeilen legst du die Reihenfolge fest. Sie gilt überall: in der App und auf dem Board.',
        moveUp: '{name} nach vorne',
        moveDown: '{name} nach hinten',
        orderNow: '{name} ist jetzt auf Platz {position} von {count}.',
        orderStale: 'In der Familie hat sich inzwischen etwas geändert. Die Liste wurde neu geladen.',
        name: 'Name',
        namePlaceholder: 'Zum Beispiel Lena',
        // 0057 (oprichter 1 okt): initialen achter de afspraak.
        initials: 'Initialen',
        initialsHint: 'Ein bis drei Buchstaben. Sie stehen im Kalender hinter dem Termin, zum Beispiel Fußball · A.',
        initialsInvalid: 'Gib ein bis drei Buchstaben ein.',
        kind: 'Wer ist es',
        kindAdult: 'Elternteil',
        kindChild: 'Kind',
        kindHelper: 'Babysitter oder Helfer',
        age: 'Alter',
        ageNone: 'Weiß ich nicht',
        ageBands: {
            '0-5': 'unter 6 Jahren',
            '6-9': '6–9 Jahre',
            '10-12': '10–12 Jahre',
            '13-15': '13–15 Jahre',
            '16+': '16 Jahre oder älter',
        },
        face: 'Gesicht',
        faceNone: 'Anfangsbuchstabe',
        preview: 'So sieht es aus',
        saved: '{name} gespeichert',
        created: '{name} gehört jetzt dazu',
        you: 'Du',
        points: 'Sammelt Punkte',
        inviteTitle: 'Lade deinen Partner ein',
        inviteBody: 'Gemeinsam planen ist einfacher. Füge deinen Partner hinzu und lade ihn dann per E-Mail ein.',
    },
    devices: {
        ...appDevicesG4De,
        title: 'Tablets',
        intro: 'Die Tablets, auf denen das Familienboard läuft.',
        add: 'Tablet koppeln',
        online: 'Online',
        seen: 'Zuletzt gesehen {ago}',
        never: 'Noch nie gesehen',
        version: 'Version {version}',
        room: 'Raum',
        rename: 'Umbenennen',
        renameTitle: 'Tablet umbenennen',
        revoke: 'Trennen',
        revokeTitle: 'Dieses Tablet trennen?',
        revokeBody: '{name} zeigt danach wieder einen Kopplungscode. Du kannst es später erneut koppeln.',
        revoked: '{name} getrennt',
        saved: 'Tablet gespeichert',
        statusRevoked: 'Getrennt',
        statusSuspect: 'Prüfen',
        emptyTitle: 'Tablet koppeln',
        emptyBody: 'Öffne das Familienboard auf dem Tablet und gib den Code hier ein.',
    },
    settings: {
        title: 'Einstellungen',
        household: 'Haushalt',
        householdName: 'Name',
        timezone: 'Zeitzone',
        wizard: 'Haushalt einrichten',
        security: 'Sicherheit',
        securityBody: 'Vertrauenswürdige Netzwerke, Browser und Sitzungen.',
        export: 'Kalender exportieren',
        exportBody: 'Lade den Kalender als .ics-Datei herunter, für die ganze Familie oder pro Person.',
        exportAll: 'Ganze Familie',
        data: 'Daten herunterladen',
        dataBody: 'Eine Kopie eurer Daten als Datei (JSON), auch die Auswahl bei „Was zu unserer Familie passt“. Du bestätigst zuerst mit deinem Passwort.',
        dataMine: 'Meine Daten',
        dataAll: 'Ganze Familie',
        dataStarted: 'Die Datei liegt in deinen Downloads.',
        about: 'Über',
        version: 'Version {version}',
        open: 'Öffnen',
    },
    wizard: {
        step: 'Schritt {n} von {total}',
        step1Title: 'Willkommen zu Hause',
        step1Body: 'Gemeinsam die Woche im Blick, ohne Stress. Wir fangen mit deiner Familie an.',
        householdName: 'Name deines Haushalts',
        householdPlaceholder: 'Familie Schneider',
        yourName: 'Dein Name auf dem Board',
        yourNameHint: 'Zum Beispiel Papa oder Anna',
        step2Title: 'Wer gehört dazu?',
        step2Body: 'Gib allen eine Farbe. Ein Kind kann auch ein Tier wählen.',
        addMember: 'Noch jemanden hinzufügen',
        memberAdded: '{name} hinzugefügt',
        step3Title: 'Erste Aufgaben',
        step3Body: 'Tippe ein paar feste Aufgaben an. Du kannst später alles ändern.',
        step3For: 'Für die Kinder',
        step3Added: {
            one: '{count} Aufgabe hinzugefügt',
            other: '{count} Aufgaben hinzugefügt',
        },
        step3NoKids: 'Füge zuerst ein Kind hinzu, um Aufgaben zu vergeben.',
        step4Title: 'Tablet koppeln',
        step4Body: 'Öffne das Familienboard auf dem Tablet im Wohnzimmer und gib den Code ein.',
        pairNow: 'Tablet koppeln',
        finish: 'Fertig',
        done: 'Dein Haushalt ist bereit',
    },
    notFoundTitle: 'Diese Seite gibt es nicht',
    notFoundBody: 'Vielleicht ist der Link alt. Geh zurück zu Heute.',
    toToday: 'Zu Heute',
    crashTitle: 'Hoppla, da ging etwas schief',
    crashBody: 'Versuch es noch einmal. Klappt es nicht? Lade die Seite neu.',
    reload: 'Neu laden',
};
//# sourceMappingURL=app.de.js.map